<script lang="ts" setup>
const { t: $t } = useI18n()

import type { MachineryRubrics } from '~/types'
import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const { foreignMachineryCreationFieldsByRubric } = useFormOptionalConditions()

const machineryPublicDimensions = computed((): OneDataColumn<ApiMachineryPublicBaseSelect>[] => [
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.mast'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.mast ? $t(`machinery.mast.${receptionMachinery.mast}`) : undefined,
    isVisible: ({ machineryRubric, category }) => foreignMachineryCreationFieldsByRubric.mast.includes(machineryRubric as MachineryRubrics) || category === 'platform',
  },
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.liftingHeight'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.liftingHeightInMillimeters?.toLocaleString('de-DE'),
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.liftingHeightInMillimeters.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.overallHeight'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => {
      const heightInMillimeters = receptionMachinery?.mastOverallHeightInMillimeters ?? receptionMachinery?.overallHeightInMillimeters
      return heightInMillimeters?.toLocaleString('de-DE')
    },
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.mastOverallHeightInMillimeters.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.forkCarriageWidth'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.forkCarriageWidthInMillimeters?.toLocaleString('de-DE'),
    isVisible: ({ category }) => category !== 'platform',
  },
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.fem'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.fem,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.fem.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('customerModule.machinery.details.machinery.dimensionsColumn.workHeightInMillimeters'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.workHeightInMillimeters,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.workHeightInMillimeters.includes(machineryRubric as MachineryRubrics),
  },
])
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.machinery.dimensions')" :is-loading="isLoading">
    <template #headerExtra>
      <slot name="headerExtra" />
    </template>
    <TableOneDataColumn :config="{ data: machinery, columns: machineryPublicDimensions }" class="text-base" />
  </CustomerModuleDataCard>
</template>
